import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set page title
document.title = 'El Interruptor Digital';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
// Safe Meta Pixel loader - no DOM manipulation, just appends to head
function loadMetaPixel() {
  if (typeof window === 'undefined') return;
  if (window.fbq) return;
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  window.fbq = n;
  window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', '846969475009809');
  window.fbq('track', 'PageView');
}
// Load pixel after React renders
setTimeout(loadMetaPixel, 0);
render(<App data-id="element-222" />, document.getElementById('root'));